import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { OrderItem } from "../../order/model/orderItemcategory.model";

export class Item extends EntityBase {
  public GoodsId?: number;
  public Title: string;
  public Code: number;
  public Title_En: string;
  public Description: string;
  public Description_En: string;
  public ApplyTax?: boolean;
  public ApplyService?: boolean;
  public Ingredients: string;
  public ItemTypeId: number;
  public ItemTypeTitle: string;
  public Ingredients_En: string;
  public CookingTime?: number;
  public Calories?: number;
  public CategoryId?: number;
  public MeasurementUnitId: number;
  public MeasurementUnitTitle: string;
  public TitleDisabled: boolean;
  public TaxApplyTypeId?: number;
  public TaxApplyTypeTitle: string;
  public TaxApplyTypeCode?: number;
  public ServiceApplyTypeId?: number;
  public ServiceApplyTypeTitle: string;
  public ServiceApplyTypeCode?: number;
  public SalePriceTypeId?: number;
  public StockInWeb: StockInWebKind;
  public Price?: number;
  public Barcodes: ItemBarcode[];
  public Dependents: ItemDependency[];
  public Prices: ItemPrice[];
  public Branches: ItemBranch[];
  public Tax?: number;
  public Toll?: number;
  public PackingPrice?: number;
  public DelinoId?: number;
  public ItemCategory: string;
  public CategoryTitle: string;
  public DetailLedgerId: number;
  public ItemSerial: string;
  public DataDaysWeekTitle: string | string[];
  public IsOrganizationalDiscount?: boolean;
  public OrganizationalDiscount?: number;
  public DaysTitle: string | string[];
  public UsedInInvDailyVoucher: boolean;
  public UsedInInvDailyVoucherClone: boolean;
}

export class ItemBarcode extends EntityBase {
  public Title: string;
  public Code: string;
}
export class ItemDependency extends EntityBase {
  public ItemDependencyTypeId: number;
  public ItemDependencySaleMethodBranch: ItemDependencySaleMethodBranch[];
  public ItemDependencySaleMethodBranchTitle: string;
  public ItemDependencyTypeTitle: string;
  public ItemDependencyTypeCode?: number;
  public Quantity: number;
  public ItemId: number;
  public DependentItemId: number;
  public DependentItem: OrderItem;
}

export class ItemDependencySaleMethodBranch extends EntityBase {
  public ItemDependencyId: number;
  public SaleMethodId: number;
  public Title: string;
}
export class ItemPrice extends EntityBase {
  public Price: number;
  public IsDefault: boolean;
  public SalePriceTypeId: number;
  public SalePriceTypeTitle: string;
  public ItemId: number;
}
export class ItemBranch extends EntityBase {
  public BranchId: number;
  public IsActive: boolean;
  public BranchTitle: string;
  public Selected: boolean;
  public ItemId: number;
  public DeactiveInDelino: boolean;
  public DeactiveInKiock: boolean;
  public DeactiveInDigitalMenu: boolean;
  public StockInWeb: StockInWebKind;
  public StockInWebTitle: string;
}

export enum BarCodeType {
  /// <summary>
  ///  با اعشار
  /// </summary>
  WithDECIMAL = 2,

  /// <summary>
  /// بدون اعشار
  /// </summary>
  WithoutDECIMAL = 5,
}

export enum TaxServiceApplyType {
  /// <summary>
  /// اعمال از سرگروه
  /// </summary>
  ApplyFromGroup = 1,

  /// <summary>
  /// اعمال شود
  /// </summary>
  IsApply = 2,

  /// <summary>
  /// اعمال نشود
  /// </summary>
  NotApply = 3,
}

export enum ItemType {
  /// <summary>
  /// کالا
  /// </summary>
  Goods = 1,

  /// <summary>
  /// خدمت
  /// </summary>
  Service = 2,
}

export enum StockInWebKind {
  Available = 0,
  UnAvailableOnSite = 1,
  UnAvailable = 2,
  UnAvailableFromInv = 3,
}

export enum CategoryPopupState {
  AllAvailable = 0,
  AllNonAvailable = 1,
  Multi = 2,
}
